import { createGetch } from '@golden/gdk-base';
export const getch = createGetch('', 5000);
export const makeImageRequest = (baseURL, timeout) => ({
    baseURL,
    timeout,
    headers: {},
    responseType: 'blob',
    method: 'GET',
    url: `/20KB.png?time=${Date.now()}`
});
export const makeDomainRequest = (baseURL, timeout, queries) => ({
    baseURL,
    timeout,
    headers: {
        Accept: 'application/json'
    },
    responseType: 'json',
    method: 'GET',
    url: `/domains${queries}`
});
//# sourceMappingURL=getch.js.map